let baseURL
switch (process.env.NODE_ENV) {
    case 'development':
        baseURL = 'https://prod.api.candibell.com'
        break
    case 'production':
        baseURL = 'https://prod.api.candibell.com'
        break
    default:
        baseURL = 'https://prod.api.candibell.com'
        break
}

let stripe_public_key = "pk_live_nbr7kT3P3aIRIrkgALGuvni1";  // production
//let stripe_public_key = "pk_test_7oofYoJdL1HnJTitjIsBhlum";   // test


export default {
    baseURL, stripe_public_key
}